<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="screening?.applicant_name"
      [canGoBack]="!windowService.isDesktopRes" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (loaded && screening) {

      <!-- Person summary -->
      <tidy-card>
        <tidy-row [alignLastItemRight]="true" class="vertical-align-center">
          <tidy-text [header]="screening.applicant_name" [translate]="false" />
          <tidy-text [body]="screening.status" [translate]="false" [ngStyle]="{ color: statusColor(screening.status) }" />
        </tidy-row>
        <tidy-row class="vertical-align-center">
          <tidy-image [src]="'assets/svg/mail-outline.svg'" class="body-size" />
          <tidy-text [body]="screening.email" [translate]="false" />
        </tidy-row>
        <tidy-row class="vertical-align-center">
          <tidy-image [src]="'assets/svg/call-outline.svg'" class="body-size" />
          <tidy-text [body]="screening.phone" [translate]="false" />
        </tidy-row>
        <tidy-row class="vertical-align-center">
          <tidy-image [src]="'assets/svg/home-outline.svg'" class="body-size" />
          <tidy-text [body]="screening.property_name + '  ·  ' + screening.applicant_type" [translate]="false" />
        </tidy-row>
        @if (roomContext) {
          <tidy-row class="vertical-align-center">
            <tidy-image [src]="'assets/svg/key-outline.svg'" class="body-size" />
            <tidy-text [body]="roomContext" [translate]="false" />
          </tidy-row>
        }
      </tidy-card>

      <!-- Screening report -->
      <tidy-row><tidy-text [title]="'Tenant Screening'" /></tidy-row>

      @if (screening.status === 'Completed') {
        <tidy-card>
          <tidy-row class="vertical-align-center">
            <div [ngStyle]="{ 'width': '12px', 'height': '12px', 'border-radius': '50%', 'background-color': recommendationColor(screening.recommendation), 'margin-right': '8px', 'flex-shrink': '0' }"></div>
            <tidy-text [header]="recommendationLabel(screening.recommendation)" [translate]="false" [ngStyle]="{ color: recommendationColor(screening.recommendation) }" />
          </tidy-row>

          <tidy-divider />

          <tidy-row class="extra-top-padding" [alignLastItemRight]="true">
            <tidy-text [body]="'Credit Score'" />
            <tidy-text
              [body]="screening.credit_score !== null ? (screening.credit_score + '  ·  ' + creditBand(screening.credit_score)) : 'Pending'"
              [translate]="false" />
          </tidy-row>
          <tidy-row [alignLastItemRight]="true">
            <tidy-text [body]="'Income Verification'" />
            <tidy-text
              [body]="screening.income_verified ? ('Verified · ' + (screening.income_to_rent_ratio | number:'1.1-1') + 'x rent') : 'Not verified'"
              [translate]="false"
              [ngStyle]="{ color: screening.income_verified ? '#2E7D32' : '#999' }" />
          </tidy-row>
          @if (screening.monthly_income) {
            <tidy-row [alignLastItemRight]="true">
              <tidy-text [body]="'Income / Rent'" />
              <tidy-text [body]="'$' + screening.monthly_income.toLocaleString('en-US') + ' / $' + (screening.monthly_rent || 0).toLocaleString('en-US') + ' mo'" [translate]="false" />
            </tidy-row>
          }
          <tidy-row [alignLastItemRight]="true">
            <tidy-text [body]="'Criminal Background'" />
            <tidy-text [body]="checkLabel(screening.criminal)" [translate]="false" [ngStyle]="{ color: checkColor(screening.criminal) }" />
          </tidy-row>
          <tidy-row [alignLastItemRight]="true">
            <tidy-text [body]="'Eviction History'" />
            <tidy-text [body]="checkLabel(screening.eviction)" [translate]="false" [ngStyle]="{ color: checkColor(screening.eviction) }" />
          </tidy-row>

          <tidy-divider />

          <tidy-row class="extra-top-padding">
            <tidy-text
              [helper]="'Screening by ' + screening.provider + ' · completed ' + (screening.completed_at | date:'MMM d, yyyy') + '. Reports are FCRA-regulated — an adverse action notice is sent automatically on decline.'"
              [translate]="false" />
          </tidy-row>
        </tidy-card>

        <tidy-row class="extra-top-padding">
          <tidy-button [text]="'Download Full Report'" [action]="downloadAction" class="primary" />
        </tidy-row>
      }

      @if (screening.status !== 'Completed') {
        <tidy-card>
          <tidy-row class="vertical-align-center">
            <div [ngStyle]="{ 'width': '12px', 'height': '12px', 'border-radius': '50%', 'background-color': statusColor(screening.status), 'margin-right': '8px', 'flex-shrink': '0' }"></div>
            <tidy-text
              [header]="screening.status === 'Invite sent' ? 'Invite sent — awaiting applicant' : 'Screening in progress'"
              [translate]="false" />
          </tidy-row>
          <tidy-row class="extra-top-padding">
            <tidy-text
              [helper]="screening.status === 'Invite sent'
                ? (screening.applicant_name + ' has been emailed a secure link to authorize their FCRA screening. Results appear here once they complete it.')
                : ('The screening for ' + screening.applicant_name + ' is being processed by ' + screening.provider + '. Results usually return within minutes.')"
              [translate]="false" />
          </tidy-row>
        </tidy-card>

        <tidy-row class="extra-top-padding">
          <tidy-button [text]="'Send a Reminder'" [action]="remindAction" class="secondary" />
        </tidy-row>
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
